import React from 'react'
import { NavLink } from 'react-router-dom'

const Submenu: React.FC = () => {
	return (
		<div className="submenu">
			<div>
				<NavLink
					to="/stories/top"
					exact
					className="remove-decoration submenu-link h-full flex-center remove-tap-highlight"
					activeClassName="submenu-active">
					Top Stories
				</NavLink>
				<NavLink
					to="/stories/best"
					exact
					className="remove-decoration submenu-link h-full flex-center remove-tap-highlight"
					activeClassName="submenu-active">
					Best Stories
				</NavLink>
				<NavLink
					to="/stories/new"
					exact
					className="remove-decoration submenu-link h-full flex-center remove-tap-highlight"
					activeClassName="submenu-active">
					New Stories
				</NavLink>
			</div>
		</div>
	)
}

export default Submenu
